import { Phone } from 'lucide-react';
import { Alert } from '@/components/ui/alert';
import { Spinner } from '@/components/ui/spinner';
import { ProductCard } from '@/features/products/ProductCard';
import { PUBLIC_CATEGORY, groupByCategory, usePublicProducts } from '@/features/products/usePublicProducts';
import { useContact } from '@/features/settings/useSiteSettings';

export const ProductListPage = () => {
  const contact = useContact();
  const products = usePublicProducts();

  return (
    <div className="mx-auto w-full max-w-[1220px] px-4 py-12 sm:px-6">
      <title>Bérelhető eszközök – Ápolási betegágy bérlés</title>
      <meta
        name="description"
        content="Elektromos betegágyak, antidecubitus és hagyományos matracok, betegápolási segédeszközök bérlése havi díjjal, kiszállítással Zala, Vas és Somogy vármegyében."
      />

      <div className="max-w-[60ch]">
        <h1 className="text-3xl">Mit lehet bérelni?</h1>
        <p className="mt-4 text-lg text-ink-soft">
          Minden eszközt kiszállítás előtt átvizsgálunk. Ha nem biztos benne, mire van szüksége, hívjon
          minket – segítünk összeválogatni.
        </p>
        <a
          href={contact.phoneHref}
          className="mt-5 inline-flex min-h-12 items-center gap-2.5 rounded-md border-2 border-teal bg-teal px-6 font-display text-lg font-bold text-navy-deep no-underline hover:bg-teal-light"
        >
          <Phone className="size-5" aria-hidden="true" />
          {contact.phone}
        </a>
      </div>

      {products.isLoading && <Spinner label="Eszközök betöltése…" />}

      {products.isError && (
        <Alert tone="danger" title="Az eszközök listája most nem érhető el" className="mt-10">
          Kérjük, frissítse az oldalt, vagy hívjon minket telefonon.
        </Alert>
      )}

      {products.data &&
        groupByCategory(products.data).map(({ category, items }) => {
          const meta = PUBLIC_CATEGORY[category];

          return (
            <section key={category} id={meta.anchor} aria-labelledby={`${meta.anchor}-cim`} className="mt-14 scroll-mt-24">
              <h2 id={`${meta.anchor}-cim`} className="text-2xl">
                {meta.title}
              </h2>
              <p className="mt-2 max-w-[60ch] text-ink-soft">{meta.lead}</p>

              <ul className="mt-6 grid list-none gap-5 p-0 sm:grid-cols-2 lg:grid-cols-3">
                {items.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </ul>
            </section>
          );
        })}
    </div>
  );
};
